function ambassadorGradient() {
    return `linear-gradient(135deg, rgba(0,124,255,0.5) -5%, rgba(6,17,48,1) 10%, rgba(6,17,48,1) 92%, rgba(0,124,255,0.5) 130%)`;
  }
  
  export default ambassadorGradient;
  